<template>
  <svg class="animate-spin" viewBox="0 0 50 50">
    <circle class="spinner-path" cx="25" cy="25" r="20" fill="none" stroke-width="7"></circle>
  </svg>
</template>
<style>
.spinner-path {
  stroke: currentColor;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: -35;
}
</style>
